import { OfferCheckoutResponseDto } from '../../types/response';
import OfferCheckoutForm, { OfferCheckoutFormProps } from '../offer-checkout-form/offer-checkout-form';
import OfferSummary from '../offer-summary/offer-summary';

/** What the view needs of an offer – the admin preview builds the same shape from its form values. */
export type OfferCheckoutViewData = Pick<OfferCheckoutResponseDto, 'product' | 'addOns' | 'customer' | 'paymentMethod' | 'offerFileName' | 'startDateOptions'>;

export interface OfferCheckoutViewProps extends Pick<OfferCheckoutFormProps, 'onSubmit' | 'validateBankDetails'> {
  offer: OfferCheckoutViewData;
  termMonths: number;
  /** Opens the offer PDF – without it (preview) the link is shown but does nothing. */
  onDownloadOfferFile?: () => void;
}

/**
 * The whole checkout – used by the public page and the admin live preview.
 * Desktop: two columns in the height the parent gives it, each scrolling on its own. Mobile: summary on top, page scrolls.
 */
const OfferCheckoutView = ({ offer, termMonths, onSubmit, validateBankDetails, onDownloadOfferFile }: OfferCheckoutViewProps) => (
  <div className="flex w-full flex-col gap-4 lg:h-full lg:flex-row">
    <div className="lg:h-full lg:w-1/2">
      <OfferSummary
        product={offer.product}
        addOns={offer.addOns}
        termMonths={termMonths}
        offerFileName={offer.offerFileName}
        onDownloadOfferFile={onDownloadOfferFile}
      />
    </div>
    <div className="flex lg:h-full lg:w-1/2 lg:overflow-y-auto">
      <div className="m-auto w-full px-6 py-10">
        <OfferCheckoutForm
          customer={offer.customer}
          paymentMethod={offer.paymentMethod}
          startDateOptions={offer.startDateOptions}
          onSubmit={onSubmit}
          validateBankDetails={validateBankDetails}
        />
      </div>
    </div>
  </div>
);

export default OfferCheckoutView;
